import { useParams } from "react-router-dom";
import Products from "./Products";

function ProductsWrapper() {
  const { slug } = useParams();

  return <Products key={slug} />;
}

export default ProductsWrapper;